import React from "react";
import { PublicRoutesProps } from "./type";
import { Box } from "@chakra-ui/react";
// import { useSelector } from "react-redux";
// import { useLocation, Navigate } from "react-router-dom";
// import { RootState } from " ../../store/rootReducer";

const PublicRoutes: React.FC<PublicRoutesProps> = ({ Component }) => {
  return (
    <Box
    // fontFamily="body"
    >
      <Component />
      {/* <div>PublicRoutes </div> */}
    </Box>
  );
};

export default PublicRoutes;

// const files = {
//   Application: {
//     Abstractions: {
//       Integrations: [
//         "IThirdPartyBillingApi.cs",
//         "ICredentialProvider.cs",
//         "IRoleResolver.cs",
//       ],
//       Persistence: {
//         Payments: [
//           "IPaymentTransactionStore.cs",
//           "IPaymentRefSessionStore.cs",
//           "IIdempotencyLedgerStore.cs",
//         ],
//         Categories: [
//           "ICategoriesQueryRepository.cs",
//           "ICategoriesCommandRepository.cs",
//         ],
//         Users: ["IUserQueryRepository.cs", "IUserCommandRepository.cs"],
//       },
//       Caching: ["ICacheService.cs"],
//       Sessions: ["ISessionRepository.cs", "ISessionStorage.cs"],
//       Tokens: ["ITokenStorage.cs", "IRefreshTokenStorage.cs"],
//       Security: ["IThirdPartyApiTokenProvider.cs", "IUserContext.cs"],
//       Ids: ["IPaymentRefIdGenerator.cs"],
//       Audit: ["IEventAuditStore.cs"],
//     },
//     DTOs: {
//       Payments: [
//         "CreatePaymentDto.cs",
//         "TxnOverviewDto.cs",
//         "BillFetchDto.cs",
//         "BillPaymentDto.cs",
//       ],
//       Auth: ["LoginReqDto.cs", "RegisterReqDto.cs"],
//     },
//     UseCases: {
//       Payments: {
//         Commands: [
//           "BillPaymentCommand.cs",
//           "StartPaymentRefSession.cs",
//           "CompleteFailPaymentRefSession.cs",
//         ],
//         Queries: [
//           "FetchBillQuery.cs",
//           "GetTransactionStatusQuery.cs",
//           "GetPaymentOverviewQuery.cs",
//         ],
//       },
//       Categories: {
//         Queries: [
//           "GetAllBillersQuery.cs",
//           "GetBillersByRegionQuery.cs",
//           "GetBillerByIdQuery.cs",
//           "GetPlansQuery.cs",
//         ],
//       },
//       Auth: {
//         Commands: ["RegisterUserCommand.cs"],
//         Queries: ["LoginUserQuery.cs"],
//       },
//     },
//     Services: ["PaymentRefSessionService.cs"],
//     Behaviors: ["ValidationBehavior.cs"],
//     Http: ["PaymentRefDelegatingHandler.cs"],
//     Common: [
//       "JwtTokenGenerator.cs",
//       "Validators/*",
//       "Mappings/UserProfile.cs",
//     ],
//     "DependencyInjection.cs": [],
//   },
// };

// const { isAuthenticated } = useSelector((state: RootState) => state.user);
// const location = useLocation();

// if (!isAuthenticated) {
//   console.log("PrivateRoutes Component:", Component);
//   return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
// }
//  const env = process.env.REACT_APP_BASE_URL
